<template>

  <v-card :if="image" style="-ms-interpolation-mode: nearest-neighbor!important; // IE 7+ (non-standard property)
              image-rendering: -webkit-optimize-contrast!important; // Safari 6, UC Browser 9.9
              image-rendering: -webkit-crisp-edges!important; // Safari 7+
              image-rendering: -moz-crisp-edges!important; // Firefox 3.6+
              image-rendering: -o-crisp-edges!important; // Opera 12
              image-rendering: pixelated!important; // Chrome 41+ and Opera 26+;cursor: pointer">
    <span style="position:absolute;z-index:2;font-size:30px;top:5%;left:5%">&nbsp;{{image.name}}</span>
    <!-- <img :src="image.icon" height="400px" > -->
    <v-img  :src="image.icon" height="400px"></v-img>
    <!-- <v-img :src="image.icon" width=""></v-img> -->
    <v-card-actions class="px-4">
      <v-layout align-center justify-center row fill-height py-3>
        <v-flex xs10>
        
          <p v-if="broker == 'CIFRASEG S.A.'" class="caption text--secondary" style="font-size:13.5px!important; color:#081e3f !important">
             {{externalProductionReport.description}}
          </p>
          <p v-if="broker != 'CIFRASEG S.A.'" class="caption text--secondary" style="font-size:13.5px!important; color:#081e3f !important">
             {{texto}}
          </p>
        </v-flex>
      </v-layout>
      <!--  <v-spacer></v-spacer> -->
      <v-btn v-if="broker == 'CIFRASEG S.A.'" small color="accent" dark :href="image.url" target="_blank">{{$t('message.open')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  mounted() {
    this.$store.dispatch("getBroker");
  },
  computed: {
    ...mapGetters(["externalProductionReport", "loadingExternal","agency", "broker"])
  },
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      texto: "No autorizado para visualizar el reporte"
    };
  },

  methods: {}
};
</script>
<style scope>
.absolute {
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 50px;
  padding-top: 50px;
}
</style>
